<template>
  <el-dialog
    :title="title" width="750px"
    append-to-body show-close
    :before-close="close" :visible.sync="visible"
    :close-on-click-modal="false" center>
    <div
      v-loading="loading"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <el-form
        :model="form" :rules="rules"
        ref="Form" label-width="100px" label-suffix=":">
        <el-form-item label="ID" prop="id">
          <el-tag v-if="form.id" type="primary">{{ form.id }}</el-tag>
          <el-tag v-else type="info">待生成</el-tag>
        </el-form-item>
        <el-form-item label="附件名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入附件名称" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="附件标识" prop="symbol">
          <el-input v-model="form.symbol" placeholder="请输入附件标识" :maxlength="30" :disabled="form.id !== null"></el-input>
        </el-form-item>
        <el-form-item label="附件类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择附件类型" disabled>
            <el-option v-for="item in annexTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否必传" prop="saveMust">
          <el-checkbox v-model="form.saveMust">附件必传</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="loading" @click="close">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { dialogMixins } from '@/mixins/dialogMixins'
import annexTypeList from '../data/annexTypeList'
import { saveOrUpdate } from '@/api/employeeAnnex'
export default {
  name: 'AnnexOperator',
  mixins: [dialogMixins],
  props: {
    flush: {
      type: Function,
      default: () => { }
    }                                                                                                                                                                                                                                                                                                                                                                            
  },
  data() {
    return {
      annexTypeList,
      loading: false,
      form: {
        id: null,
        name: '',
        symbol: '',
        type: 2,
        saveMust: false,
      },
      rules: {
        name: [
          { required: true, message: '请输入附件名称', trigger: 'blur' },
        ],
        symbol: [
          { required: true, message: '请输入附件标识', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择附件类型', trigger: 'change' },  
        ]
      },
    }
  },
  mounted() { },
  computed: {
    title() {
      return this.form.id ? '附件信息更新' : '附件信息新增'
    }
  },
  methods: {
    init(data) {
      if (data !== null) {
        this.form = Object.assign({}, data)
      } else {
        this.$refs.Form.resetFields()
      }
    },
    submit() {
      this.$refs.Form.validate(async valid => {
        if (valid) {
          const text = this.form.id ? '更新' : '新增'
          const conf = await this.$confirm(`将要${text}附件信息，请确定是否继续？`, '提示', {
            type: 'warning'
          }).catch(err => err)
          if (conf !== 'confirm') return this.$message.info('已取消操作')
          this.loading = true
          const { data: res } = await saveOrUpdate(this.form).catch(err => err)
          if (res) {
            this.$message.success('操作成功')
            this.$refs.Form.resetFields()
            this.flush()
            this.close()
          }
          this.loading = false
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
</style>
